<template>
  <v-container>
    <!-- <v-row no-gutters id="highlight">
      <v-col :align-self="$vuetify.breakpoint.mdAndUp ? 'center' : 'start'">
        <h1 class="highlight--title">Central de Ajuda</h1>
        <p
          class="highlight--description"
        >Para esclarecer dúvidas, dar suporte ao usuário e centralizar os incidentes, criamos a Central de Serviços Compartilhados.</p>
        <p class="highlight--description">
          Este canal tem como objetivo prover aos usuários da OI um Ponto único de Contato, um mecanismo essencial para a comunicação efetiva entre os usuários.
          <br />Oferecemos suporte proativo voltado para o reestabelecimento da operação direcionados aos usuários, em casos de indisponibilidade, o que minimiza impacto nos negócios da OI.
        </p>
        <v-btn depressed x-large color="primary" @click="$vuetify.goTo(target, options)">Ver duvidas</v-btn>
      </v-col>
      <v-col align-self="center" class="d-none d-md-flex">
        <v-img :src="require('../assets/images/help-bg.svg')" :height="imageHeight" contain></v-img>
      </v-col>
    </v-row>-->
    <h1 class="highlight--title mb-5">Qual sua dificuldade de acesso?</h1>
    <v-row id="questions">
      <Card :title="`Dificuldades com OTP?`">
        <p class="info--title">Código não reconhecido?</p>
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>Faça o sincronismo do seu APP
        </p>

        <img src="../assets/images/otp_sync_new.png" alt="Sincronismo OTP" width="190px" class="ml-6" />
        <p class="info--title">Estou sem aparelho</p>
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>
          <a @click="openOtpModal()">Clique aqui</a> e solicite ao seu gestor para utilizar temporariamente apenas a senha
        </p>
        <p class="info--title">Não lembra como usar?</p>
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>
          <a href="/p/central-ajuda/GA-Como_Usar_OTP.pdf" target="_blank">Clique aqui</a> e reveja a orientação
        </p>
      </Card>

      <Card :title="`Esqueceu a Senha?`">
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>Caso tenha o app instalado, realize a troca por lá.
        </p>
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>Ou solicite ao seu gestor
        </p>
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>Ou envie e-mail para: 
            <a href="mailto:central_servicedesk@oi.net.br">
              central_servicedesk@oi.net.br
            </a>
        </p>
      </Card>

      <Card :title="`Está sem permissão?`">
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>
          <a href="https://ga.local.srv.br/" target="_blank">Clique aqui</a> e peça permissão via GA. Você precisa estar na rede interna da empresa.
        </p>
      </Card>

      <Card :title="`Outros problemas?`">
        <p>
          <v-icon size="18" color="primary" style="color: #00D318 !important;" class="mr-1">mdi-chevron-right</v-icon>
          <a @click="openCheckAccountModal()">Clique aqui</a> e informe sua matrícula
        </p>
      </Card>
    </v-row>
    <OtpModal :active="modalOtpIsOpen" />
    <CheckAccountModal :active="modalOtpIsOpen" />
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Card from "../components/Card";
import OtpModal from "../components/OtpModal";
import CheckAccountModal from "../components/CheckAccountModal";

export default {
  components: {
    Card,
    OtpModal,
    CheckAccountModal
  },
  data() {
    return {
      target: "#questions",
      options: {
        duration: 1000,
        offset: 50,
        easing: "easeInQuad"
      }
    };
  },
  computed: {
    ...mapState(["modalOtpIsOpen"]),
    ...mapState(["modalCheckAccoutIsOpen"]),
    imageHeight() {
      switch (this.$vuetify.breakpoint.name) {
        default:
          return "450px";
        case "md":
          return "500px";
        case "lg":
          return "500px";
        case "xl":
          return "650px";
      }
    }
  },
  methods: {
    ...mapActions(["openOtpModal"]),
    ...mapActions(["openCheckAccountModal"])
  }
};
</script>

<style lang="scss">
.storesButtonsRow {
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
  /* justify-content: le; */

  .v-btn:first-child {
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .buttons--container {
    text-align: left;
  }
  .button--title {
    font-size: 18px;
    letter-spacing: 2px;
  }
  .button--subtitle {
    font-size: 10px;
    letter-spacing: 0px;
    text-transform: none;
  }
}

#highlight {
  min-height: 100vh;
  margin-top: -100px;
}
#questions {
  display: flex;
  min-height: 60vh;
  padding-bottom: 30px;
}
.highlight {
  &--title {
    font-size: 30px;
  }
}

.v-application a {
    color: #00D318 !important;
}



@media only screen and (max-width: 770px) {
  #highlight {
    min-height: unset;
    margin-top: 0px;
    margin-bottom: 40px;
  }
}

@media only screen and (max-width: 414px) {
  #questions {
    flex-direction: column;
  }
  .highlight {
    &--title {
      font-size: 26px;
    }
  }
}

@media only screen and (min-width: 1400px) {
  .highlight {
    &--title {
      font-size: 36px;
    }
    &--description {
      font-size: 18px;
    }
  }
}
</style>
